export default __webpack_public_path__ + "static/media/photo--sm--misc-7.d5515f02.jpg";